import * as React from "react";
import PropTypes from 'prop-types';

const SvgInStore = props => {
  if (props.id !== "_svginstore") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 40 40" {...props}><path fill="#202020" d="M24 20h3.4a1.6 1.6 0 011.6 1.6V30h2V12H9v18h2v-8.4a1.6 1.6 0 011.6-1.6H24zm-2 2h-4v8h4v-8zm2 0v8h3v-8h-3zm-8 0h-3v8h3v-8zm17 8h1v2H6v-2h1V11.6A1.6 1.6 0 018.6 10h22.8a1.6 1.6 0 011.6 1.6V30zM16 15h8v2h-8v-2z" fillRule="evenodd" /></svg>;
};

SvgInStore.displayName = "_svginstore";
SvgInStore.propTypes = {
  id: PropTypes.string
};
SvgInStore.defaultProps = {
  id: ''
};
export default SvgInStore;